export default {
  canvas: {
    _skip: 0,
    backgroundColor: "rgb(155,165,87)",
    backgroundImage: "",
    backgroundSize: "cover",
    blur: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "rgba(66, 66, 66, 1)",
    borderStyle: "solid",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 0,
    childDelay: 0,
    children: [
      "element_emptycontainera83fd710-a75e-11e7-8d43-ef6b7c9a9c25",
      "element_emptycontainer87c2c2c0-a75b-11e7-b798-093218a6a0e8",
      "element_imageed481640-a756-11e7-94f6-7d8195d14f61",
      "element_emptycontainer5679ecc0-b976-11e7-9d7c-6d31e2860062"
    ],
    collection: "none",
    cycle: false,
    delay: 0,
    direction: "vertical",
    enterAnimation: "none",
    gradient: "",
    height: 600,
    hideOverflow: false,
    id: "canvas",
    label: "TwitchIntro",
    leaveAnimation: "none",
    left: 0,
    limit: 10,
    maximum: 100,
    opacity: 1,
    perspective: 150,
    rotate: 0,
    rotateX: 0,
    rotateY: 0,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 0,
    space: 10,
    stayDuration: 7000,
    streamHeight: 9,
    streamWidth: 16,
    top: 0,
    transformOrigin: "50% 50% 0",
    type: "element_emptycontainer",
    width: 600,
    rules: []
  },
  "element_emptycontainer06c43a10-ba51-11e7-ae0e-61e84ef70180": {
    _skip: 0,
    backgroundColor: "rgba(26, 26, 26, 1)",
    backgroundImage: "{twitch.game_picture}",
    backgroundSize: "cover",
    blur: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "#dddddd",
    borderStyle: "solid",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 0,
    childDelay: 0,
    collection: "none",
    cycle: false,
    delay: 0,
    direction: "vertical",
    enterAnimation: "none",
    gradient: "",
    height: 0.20499999999999996,
    hidden: false,
    hideOverflow: false,
    id: "element_emptycontainer06c43a10-ba51-11e7-ae0e-61e84ef70180",
    label: "GameBoxSide",
    leaveAnimation: "none",
    left: 0.777291917973462,
    limit: 10,
    maximum: 100,
    opacity: 1,
    parent: "element_emptycontainer87c2c2c0-a75b-11e7-b798-093218a6a0e8",
    perspective: 0.16198704103671704,
    rotate: 0,
    rotateX: 0,
    rotateY: 28,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 0,
    space: 0.01079913606911447,
    stayDuration: 7000,
    top: -0.061067551266586244,
    transformOrigin: "50% 50% 0",
    type: "element_emptycontainer",
    width: 0.024464831804281346,
    rules: [],
    children: []
  },
  "element_emptycontainer5679ecc0-b976-11e7-9d7c-6d31e2860062": {
    _skip: 0,
    backgroundColor: "rgba(0, 0, 0, 0.31)",
    backgroundImage: "",
    backgroundSize: "contain",
    blur: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "rgba(20, 20, 20, 1)",
    borderStyle: "solid",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 0,
    childDelay: 0,
    children: [
      "element_progressbar567a13d0-b976-11e7-9d7c-6d31e2860062",
      "element_text567a13d1-b976-11e7-9d7c-6d31e2860062",
      "element_emptycontainer567a13d2-b976-11e7-9d7c-6d31e2860062"
    ],
    collection: "none",
    cycle: false,
    delay: 0,
    direction: "vertical",
    enterAnimation: "none",
    gradient: "",
    height: 0.07670043415340087,
    hidden: false,
    hideOverflow: true,
    id: "element_emptycontainer5679ecc0-b976-11e7-9d7c-6d31e2860062",
    label: "Starting",
    leaveAnimation: "none",
    left: 0.1437934920961024,
    limit: 10,
    maximum: 100,
    opacity: 1,
    parent: "canvas",
    perspective: 0.16198704103671704,
    rotate: 0,
    rotateX: 0,
    rotateY: 0,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 0,
    space: 0.01079913606911447,
    stayDuration: 7000,
    top: 0.31048249245384285,
    transformOrigin: "50% 50% 0",
    type: "element_emptycontainer",
    width: 0.4869753979739508,
    rules: []
  },
  "element_emptycontainer567a13d2-b976-11e7-9d7c-6d31e2860062": {
    _skip: 0,
    backgroundColor: "rgba(0, 0, 0, 0.4)",
    backgroundImage: "",
    backgroundSize: "contain",
    blur: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "#dddddd",
    borderStyle: "solid",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 0,
    childDelay: 0,
    collection: "none",
    cycle: false,
    delay: 0,
    direction: "vertical",
    enterAnimation: "none",
    gradient: "",
    height: 0.025484199796126403,
    hideOverflow: false,
    id: "element_emptycontainer567a13d2-b976-11e7-9d7c-6d31e2860062",
    label: "Triangle",
    leaveAnimation: "none",
    left: -0.013320647002854426,
    limit: 10,
    maximum: 100,
    opacity: 1,
    parent: "element_emptycontainer5679ecc0-b976-11e7-9d7c-6d31e2860062",
    perspective: 0.1274426508071368,
    rotate: 45,
    rotateX: 0,
    rotateY: 0,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 0,
    space: 0.008496176720475786,
    stayDuration: 7000,
    top: 0.026641294005708853,
    transformOrigin: "50% 50% 0",
    type: "element_emptycontainer",
    width: 0.025484199796126403,
    rules: [],
    children: []
  },
  "element_emptycontainer87c2c2c0-a75b-11e7-b798-093218a6a0e8": {
    _skip: 0,
    backgroundColor: "rgba(0, 0, 0, 0.25)",
    backgroundImage: "",
    backgroundSize: "contain",
    blur: 0,
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
    borderColor: "rgba(0, 0, 0, 1)",
    borderStyle: "solid",
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    borderWidth: 0,
    childDelay: 0,
    children: [
      "element_textebecbc80-ba50-11e7-bfca-3905ece5f668",
      "element_iconee2e2100-ba50-11e7-bfca-3905ece5f668",
      "element_textf0892800-ba50-11e7-bfca-3905ece5f668",
      "element_imagefc75fb70-ba50-11e7-bfca-3905ece5f668",
      "element_emptycontainer06c43a10-ba51-11e7-ae0e-61e84ef70180"
    ],
    collection: "none",
    cycle: false,
    delay: 100,
    direction: "vertical",
    enterAnimation: "none",
    gradient: "",
    height: 0.13748191027496381,
    hideOverflow: false,
    id: "element_emptycontainer87c2c2c0-a75b-11e7-b798-093218a6a0e8",
    label: "Status",
    leaveAnimation: "none",
    left: 0.17494600431965443,
    limit: 10,
    maximum: 100,
    opacity: 1,
    parent: "canvas",
    perspective: 0.16198704103671704,
    rotate: 0,
    rotateX: 0,
    rotateY: 0,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 0,
    space: 0.01079913606911447,
    stayDuration: 7000,
    top: 0.4095539405704202,
    transformOrigin: "50% 50% 0",
    type: "element_emptycontainer",
    width: 0.9891461649782923,
    rules: []
  },
  "element_emptycontainera83fd710-a75e-11e7-8d43-ef6b7c9a9c25": {
    _skip: 0,
    backgroundColor: "transparent",
    backgroundImage: "{twitch.profile_banner}",
    backgroundSize: "cover",
    blur: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "#dddddd",
    borderStyle: "solid",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 0,
    childDelay: 0,
    collection: "none",
    cycle: false,
    delay: 0,
    direction: "vertical",
    enterAnimation: "none",
    gradient: "",
    height: 0.2823649337410805,
    hideOverflow: false,
    id: "element_emptycontainera83fd710-a75e-11e7-8d43-ef6b7c9a9c25",
    label: "Banner",
    leaveAnimation: "none",
    left: 0,
    limit: 10,
    maximum: 100,
    opacity: 1,
    parent: "canvas",
    perspective: 0.16198704103671704,
    rotate: 0,
    rotateX: 0,
    rotateY: 0,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 0,
    space: 0.01079913606911447,
    stayDuration: 7000,
    top: 0,
    transformOrigin: "50% 50% 0",
    type: "element_emptycontainer",
    width: 1,
    rules: [],
    children: []
  },
  "element_iconee2e2100-ba50-11e7-bfca-3905ece5f668": {
    _skip: 0,
    backgroundColor: "transparent",
    blur: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "#dddddd",
    borderStyle: "solid",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 0,
    color: "rgba(185, 185, 185, 1)",
    delay: 0,
    enterAnimation: "none",
    height: 0.030237580993520512,
    icon: "user-o",
    id: "element_iconee2e2100-ba50-11e7-bfca-3905ece5f668",
    label: "IconViewers",
    leaveAnimation: "none",
    left: 0.015078407720144751,
    limit: 10,
    lockAspectRatio: true,
    maximum: 100,
    opacity: 1,
    parent: "element_emptycontainer87c2c2c0-a75b-11e7-b798-093218a6a0e8",
    perspective: 0.16198704103671704,
    rotate: 0,
    rotateX: 0,
    rotateY: 0,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 0,
    stayDuration: 7000,
    top: 0.08900502798036024,
    transformOrigin: "50% 50% 0",
    type: "element_icon",
    width: 0.030237580993520512,
    rules: [],
    children: []
  },
  "element_imageed481640-a756-11e7-94f6-7d8195d14f61": {
    _skip: 0,
    backgroundColor: "transparent",
    blur: 0,
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
    borderColor: "#dddddd",
    borderStyle: "solid",
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    borderWidth: 0,
    collection: "none",
    cycle: false,
    delay: 0,
    direction: "vertical",
    enterAnimation: "none",
    height: 0.13714902807775378,
    hidden: false,
    id: "element_imageed481640-a756-11e7-94f6-7d8195d14f61",
    label: "Logo",
    leaveAnimation: "none",
    left: 0.0183585313174946,
    limit: 10,
    lockAspectRatio: true,
    maximum: 100,
    opacity: 1,
    parent: "canvas",
    perspective: 0.16198704103671704,
    rotate: 0,
    rotateX: 0,
    rotateY: 0,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 0,
    space: 0.01079913606911447,
    stayDuration: 7000,
    top: 0.4095539405704202,
    transformOrigin: "50% 50% 0",
    type: "element_image",
    url: "{twitch.logo}",
    width: 0.13714902807775378,
    rules: [],
    children: []
  },
  "element_imagefc75fb70-ba50-11e7-bfca-3905ece5f668": {
    _skip: 0,
    backgroundColor: "transparent",
    blur: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "#dddddd",
    borderStyle: "solid",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 0,
    collection: "none",
    cycle: false,
    delay: 0,
    direction: "vertical",
    enterAnimation: "none",
    height: 0.19311396264769407,
    id: "element_imagefc75fb70-ba50-11e7-bfca-3905ece5f668",
    label: "GameBox",
    leaveAnimation: "none",
    left: 0.6355548854041014,
    limit: 10,
    lockAspectRatio: true,
    maximum: 100,
    opacity: 1,
    parent: "element_emptycontainer87c2c2c0-a75b-11e7-b798-093218a6a0e8",
    perspective: 0.16198704103671704,
    resolvedUrl: "https://static-cdn.jtvnw.net/ttv-boxart/Cuphead-272x380.jpg",
    rotate: 0,
    rotateX: 0,
    rotateY: -12,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 0,
    space: 0.01079913606911447,
    stayDuration: 7000,
    top: -0.05503618817852835,
    transformOrigin: "50% 50% 0",
    type: "element_image",
    url: "{twitch.game_picture}",
    width: 0.13822894168466524,
    rules: [],
    children: []
  },
  "element_progressbar567a13d0-b976-11e7-9d7c-6d31e2860062": {
    _skip: 0,
    backgroundColor: "rgba(0, 0, 0, 0.25)",
    backgroundImage: "",
    backgroundSize: "contain",
    blur: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "#dddddd",
    borderStyle: "solid",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 0,
    childDelay: 0,
    collection: "none",
    cycle: false,
    delay: 0,
    direction: "vertical",
    enterAnimation: "none",
    gradient: "",
    height: 0.07706945765937202,
    hideOverflow: false,
    id: "element_progressbar567a13d0-b976-11e7-9d7c-6d31e2860062",
    label: "Progress Bar",
    leaveAnimation: "none",
    left: 0,
    limit: 10,
    maximum: 100,
    opacity: 1,
    orientation: "horizontal",
    parent: "element_emptycontainer5679ecc0-b976-11e7-9d7c-6d31e2860062",
    perspective: 0.16198704103671704,
    progress: {
      target: "countdown.progress"
    },
    rotate: 0,
    rotateX: 0,
    rotateY: 0,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 0,
    space: 0.01079913606911447,
    stayDuration: 7000,
    top: 0,
    transformOrigin: "50% 50% 0",
    type: "element_progressbar",
    width: 0.48715509039010474,
    rules: [],
    children: []
  },
  "element_text567a13d1-b976-11e7-9d7c-6d31e2860062": {
    _skip: 0,
    alignItems: "center",
    backgroundColor: "transparent",
    blur: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "#dddddd",
    borderStyle: "solid",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 0,
    collection: "none",
    color: "rgba(224, 220, 220, 1)",
    cycle: false,
    delay: 0,
    direction: "vertical",
    enterAnimation: "none",
    fontFamily: "Fira Sans",
    fontSize: 0.032397408207343416,
    fontStyle: "normal",
    fontWeight: 400,
    height: 0.07802093244529018,
    id: "element_text567a13d1-b976-11e7-9d7c-6d31e2860062",
    label: "Text",
    leaveAnimation: "none",
    left: 0,
    letterSpacing: 3,
    limit: 10,
    lineHeight: 1.2,
    maxItems: 1,
    maximum: 100,
    minHeight: 20,
    minWidth: 20,
    opacity: 1,
    parent: "element_emptycontainer5679ecc0-b976-11e7-9d7c-6d31e2860062",
    perspective: 0.16198704103671704,
    rotate: 0,
    rotateX: 0,
    rotateY: 0,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 0,
    space: 0.01079913606911447,
    stayDuration: 7000,
    text: "STARTING IN {countdown.minute}:{countdown.second} ",
    textAlign: "center",
    textIdent: 0,
    top: 0,
    transformOrigin: "50% 50% 0",
    type: "element_text",
    width: 0.48715509039010474,
    rules: [],
    children: []
  },
  "element_textebecbc80-ba50-11e7-bfca-3905ece5f668": {
    _skip: 0,
    alignItems: "center",
    backgroundColor: "transparent",
    blur: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "#dddddd",
    borderStyle: "solid",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 0,
    collection: "none",
    color: "rgba(185, 185, 185, 1)",
    cycle: false,
    delay: 0,
    direction: "vertical",
    enterAnimation: "none",
    fontFamily: "Times New Roman",
    fontSize: 0.024838012958963276,
    fontStyle: "normal",
    fontWeight: 400,
    height: 0.0326197757390418,
    hidden: false,
    id: "element_textebecbc80-ba50-11e7-bfca-3905ece5f668",
    label: "Title",
    leaveAnimation: "none",
    left: 0.0180940892641737,
    letterSpacing: 3,
    limit: 10,
    lineHeight: 1.3,
    maxItems: 1,
    maximum: 100,
    minHeight: 20,
    minWidth: 20,
    opacity: 1,
    parent: "element_emptycontainer87c2c2c0-a75b-11e7-b798-093218a6a0e8",
    perspective: 0.16198704103671704,
    rotate: 0,
    rotateX: 0,
    rotateY: 0,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 0,
    space: 0.01079913606911447,
    stayDuration: 7000,
    text: "{twitch.status}",
    textAlign: "left",
    textIdent: 0,
    top: 0.024879372738238842,
    transformOrigin: "50% 50% 0",
    type: "element_text",
    width: 0.6034658511722731,
    rules: [],
    children: []
  },
  "element_textf0892800-ba50-11e7-bfca-3905ece5f668": {
    _skip: 0,
    alignItems: "center",
    backgroundColor: "transparent",
    blur: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "#dddddd",
    borderStyle: "solid",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 0,
    collection: "none",
    color: "rgba(185, 185, 185, 1)",
    cycle: false,
    delay: 0,
    direction: "vertical",
    enterAnimation: "none",
    fontFamily: "Times New Roman",
    fontSize: 0.024838012958963276,
    fontStyle: "normal",
    fontWeight: 400,
    height: 0.0581039755351682,
    id: "element_textf0892800-ba50-11e7-bfca-3905ece5f668",
    label: "ViewersCount",
    leaveAnimation: "none",
    left: 0.060313630880579006,
    letterSpacing: 0.0028089887640449437,
    limit: 10,
    lineHeight: 2.5,
    maxItems: 1,
    maximum: 100,
    minHeight: 20,
    minWidth: 20,
    opacity: 1,
    parent: "element_emptycontainer87c2c2c0-a75b-11e7-b798-093218a6a0e8",
    perspective: 0.16198704103671704,
    rotate: 0,
    rotateX: 0,
    rotateY: 0,
    showEvery: 0,
    showWhen: "",
    skewX: 0,
    skewY: 0,
    skip: 0,
    space: 0.01079913606911447,
    stayDuration: 7000,
    text: "{twitch.viewers} viewers",
    textAlign: "left",
    textIdent: 0,
    top: 0.075,
    transformOrigin: "50% 50% 0",
    type: "element_text",
    width: 0.35,
    rules: [],
    children: []
  }
};



// WEBPACK FOOTER //
// ./src/constants/templates/twitchIntro.js